import React, { memo, useEffect } from 'react';
import {
  Stack,
  Card,
  Typography,
  Divider,
  LinearProgress,
  Icon,
  Chip,
  Rating,
  Box
} from 'investira.react.components';

const QuestaoCardRating = memo(props => {
  const { rating, name = 'rating-hover', precision = 1, max = 4, readOnly, onChange } = props;

  const [value, setValue] = React.useState(0);
  const [hover, setHover] = React.useState(-1);

  const labels = {
    1: 'Ruim',
    2: 'Regular',
    3: 'Bom',
    4: 'Ótimo',
    5: 'Excelente'
  };

  function getLabelText(value) {
    return `${value} Estrela${value !== 1 ? 's' : ''}, ${labels[value]}`;
  }

  useEffect(() => {
    setValue(rating);
  }, []);

  useEffect(() => {
    onChange && onChange(value);
  }, [value]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      //justifyContent="end"
      py={1}
      gap={2}
      sx={{
        pointerEvents: 'auto'
        // backgroundColor: 'red'
      }}
      onClick={e => {
        e.stopPropagation();
      }}
      onMouseDown={e => {
        e.stopPropagation();
      }}
      onMouseUp={e => {
        e.stopPropagation();
      }}
      onDoubleClick={e => {
        e.stopPropagation();
      }}>
      <Typography variant="caption" color="textSecondary">
        Avaliação
      </Typography>
      <Rating
        readOnly={readOnly}
        name={name}
        value={value}
        precision={precision}
        getLabelText={getLabelText}
        max={max}
        onChange={(e, newValue) => {
          e.stopPropagation();
          e.preventDefault();
          setValue(hover === -1 ? null : newValue);
        }}
        onChangeActive={(e, newHover) => {
          e.stopPropagation();
          e.preventDefault();
          setHover(newHover);
        }}
      />
      <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
        {value !== null && <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>}
      </Typography>
    </Stack>
  );
});

export default QuestaoCardRating;
